module.exports = __webpack_public_path__ + "107965aaf0697cc3840450e0c2230a0e.png";